import React from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col, Button, ListGroup, ListGroupItem, Form, FormGroup, Label, Input } from 'reactstrap';
import './SearchList.css';
import Axios from 'axios';
import BimeManager from '../../Core/BimeManager';
import UserManager from '../../Core/UserManager';
import { framework, ui, libs } from 'saffroncodejs';
var PageManager = framework.PageManager;
class SearchList extends React.Component {
  bid = null;
  bid2 = null;
  reashte2 = null;
  constructor(props) {
    super(props);
    var urlParams = PageManager.decodePageParams(props);
    this.bid2 = this.encodeSodurId(urlParams[0]);
    this.bid = this.bid2;
    this.reashte2 = this.encodeSodurId(urlParams[1]);
    this.setreshtebimei = this.setreshtebimei.bind(this);
    this.setshomarebimename = this.setshomarebimename.bind(this);
    this.setDateDay = this.setDateDay.bind(this);
    this.setDateMonth = this.setDateMonth.bind(this);
    this.setDateYear = this.setDateYear.bind(this);
    this.setDateDay2 = this.setDateDay2.bind(this);
    this.setDateMonth2 = this.setDateMonth2.bind(this);
    this.setDateYear2 = this.setDateYear2.bind(this);
    this.redirect = this.redirect.bind(this);
    this.redirectPay = this.redirectPay.bind(this);
    this.filter = this.filter.bind(this);
    this.removeFilter = this.removeFilter.bind(this);
    if (this.setDateDay === "null" || this.setDateMonth === "null" || this.setDateYear === "null") {
      this.date1 = ''
    }
    else {
      this.date1 = this.setDateDay + '/' + this.setDateMonth + '/' + this.setDateYear;
    }
    if (this.setDateDay2 === "null" || this.setDateMonth2 === "null" || this.setDateYear2 === "null") {
      this.date2 = ''
    }
    else {
      this.date2 = this.setDateDay2 + '/' + this.setDateMonth2 + '/' + this.setDateYear2;
    }
    this.state = {
      isloading: true,
      reshtebimei: "",
      shomarebime: "",
      number1: "",
      number2: "",
      number3: "",
      number4: '',
      number5: '',
      number6: '',
      activeTab: 1,
      isLoading: true,
      btns: [
        {
          btnId: '1', textBtn: 'پرداخت شده ها', content: [
          ]
        },
        {
          btnId: '2', textBtn: 'پرداخت نشده ها', content: [
          ]
        },
      ],
      data: [{ "RowNo": 1, "SrdId": null, "BId": 379089, "ReshteCaption": "اتومبيل - بدنه", "ReshteId": 4, "FullBNo": "92/28/99/99/3522964", "ElhNo": 0, "Sharh": "صندوق شماره 28193789 تاريخ ‎1392/11/09", "Date": "1392/11/09", "Amount": 589688, "BimeGozarId": 2040420, "Bimegozar": "روزيتا حقيقي کد 2040420", "Codemelli": "0062878115", "Payable": 0, "Paid": 1, "ErrorMessage": null }]
    }
    this.state.data = [];
    this.state.dataPardakhtShode = [];
    this.state.datareshte = [];
    this.state.datapardakhtnashode = [];
    this.state.datapardakhtE = [];
    this.loadDetail();
  }
  encodeSodurId(encodedId) {
    return encodedId;
  }

  componentWillReceiveProps(props) {
    var urlParams = PageManager.decodePageParams(props);
    this.bid2 = this.encodeSodurId(urlParams[0]);
    this.reashte2 = this.encodeSodurId(urlParams[1]);
    this.loadDetail();
  }


  loadDetail() {



    Axios.post(BimeManager.reactRedirectDomain,

      BimeManager.makeBody("/NovinInsuranceServices/Ml/api/Ml/ReshteForCustomerPayStatus",

        { codeMelli: UserManager.MelliCode() }
      ),
      BimeManager.header())
      .then((result) => {

        if (this.reashte2) {
          this.setState({ datareshte: result.data.filter(u => u.ReshteId === Number(this.reashte2)) });
        }
        else {
          this.setState({ datareshte: result.data });
        }

         console.log("datareshte1******: ", this.state.datareshte);

      })
      .catch((error) => { alert(error) })

    Axios.post(BimeManager.reactRedirectDomain,

      BimeManager.makeBody("/NovinInsuranceServices/Ml/api/Ml/CustomerPayStatus",
        !this.bid2 ?
          { ReshteId: this.state.reshtebimei, codeMelli: UserManager.MelliCode(), BId: this.state.shomarebime, FromDate: "", ToDate: "", Paid: 0 }
          : { ReshteId: this.state.reshtebimei, codeMelli: UserManager.MelliCode(), BId: this.bid2, FromDate: "", ToDate: "", Paid: 0 }
      ),
      BimeManager.header())
      .then((result) => {
        console.log("result.data pardakht Nashode 2: ", result.data);
        this.setState({ datapardakhtnashode: result.data, isloading: false });


      })
      .catch((error) => { alert(error) })
    //alert(this.bid2)
    Axios.post(BimeManager.reactRedirectDomain,
      BimeManager.makeBody("/NovinInsuranceServices/Ml/api/Ml/CustomerPayStatus",
        !this.bid2 ?

          { ReshteId: this.state.reshtebimei, codeMelli: UserManager.MelliCode(), BId: this.state.shomarebime, FromDate: "", ToDate: "", Paid: 1 }
          : { ReshteId: this.state.reshtebimei, codeMelli: UserManager.MelliCode(), BId: this.bid2, FromDate: "", ToDate: "", Paid: 1 }

      ),
      BimeManager.header())
      .then((result) => {
         console.log("result.data pardakhtShode3: ", result.data);
        this.setState({ dataPardakhtShode: result.data, isloading: false });


      })
      .catch((error) => { alert(error) })

  }


  setreshtebimei(event) {
    this.setState({ reshtebimei: event.target.value });
  }

  setshomarebimename(event) {
    this.setState({ shomarebime: event.target.value });
  }

  setDateDay(event) {
    if (event.target.value === null || event.target.value === '' || event.target.value === undefined) {
      this.setState({ number1: '' });
    }
    else {
      this.setState({ number1: event.target.value });
    }
  }

  setDateMonth(event) {
    if (event.target.value === null || event.target.value === '' || event.target.value === undefined) {
      this.setState({ number2: '' });
    }
    else {
      this.setState({ number2: event.target.value });
    }

  }

  setDateYear(event) {

    if (event.target.value === null || event.target.value === '' || event.target.value === undefined) {
      this.setState({ number3: '' });
    }
    else {
      this.setState({ number3: event.target.value });
    }
  }
  setDateDay2(event) {
    if (event.target.value === null || event.target.value === '' || event.target.value === undefined) {
      this.setState({ number4: '' });
    }
    else {
      this.setState({ number4: event.target.value });
    }
  }
  setDateMonth2(event) {
    if (event.target.value === null || event.target.value === '' || event.target.value === undefined) {
      this.setState({ number5: '' });
    }
    else {
      this.setState({ number5: event.target.value });
    }
  }
  setDateYear2(event) {
    if (event.target.value === null || event.target.value === '' || event.target.value === undefined) {
      this.setState({ number6: '' });
    }
    else {
      this.setState({ number6: event.target.value });
    }
  }

  redirect(btnItem, id) {
    return ('/Detail')
  }

  redirectPay(srd) {
    this.setState({ isLoading: false });
    Axios.post(BimeManager.reactRedirectDomain,
      BimeManager.makeBody("/NovinInsuranceServices/Ml/api/Ml/EPayCode",
        {
          Codemelli: UserManager.MelliCode(),
          srdId: srd
        }
      ),
      BimeManager.header()
    )
      .then((result) => {

        window.open('http://185.184.32.33/LifeCustomersPortal/Epay/ExternalPay?ref1=' + srd + '&ref2=' + result.data.Code);
        this.setState({ isLoading: true });
      })
      .catch((error) => { alert(error) })
  }

  filter(rbimei, shbime, n3, n2, n1, n6, n5, n4) {


    if (this.state.activeTab === 1) {
      if (n1 === "" || n2 === "" || n3 === "" || n5 === "" || n6 === "" || n4 === "") {
        if ((n1 === "" & n2 === "" & n3 === "") || (n1 === "" || n2 === "" || n3 === "")) {
          var fromD = "";
        }
        else {
          fromD = n3 + '/' + n2 + '/' + n1;
        }
        if ((n4 === "" & n5 === "" & n6 === "") || (n4 === "" || n5 === "" || n6 === "")) {
          var toD = "";
        }
        else {
          fromD = n3 + '/' + n2 + '/' + n1;
          toD = n6 + '/' + n5 + '/' + n4;
        }
      }

      this.setState({ isloading: true });
      Axios.post(BimeManager.reactRedirectDomain,
        BimeManager.makeBody("/NovinInsuranceServices/Ml/api/Ml/CustomerPayStatus",
          !this.bid2 ?
            {

              ReshteId: rbimei, FromDate: fromD, ToDate: toD, Paid: 1, SanadType: "", BId: shbime, CodeMelli: UserManager.MelliCode()
            } : { ReshteId: this.reashte2, FromDate: fromD, ToDate: toD, Paid: 1, SanadType: "", BId: this.bid2, CodeMelli: UserManager.MelliCode() }
        ),
        BimeManager.header())
        .then((result) => {
          // console.log("result.data filterPardakhtShode: ", JSON.stringify(result.data));

          this.setState({ dataPardakhtShode: result.data, isloading: false });


        })
        .catch((error) => { alert(error) })
    }
    else {
      if (n1 === "" || n2 === "" || n3 === "" || n5 === "" || n6 === "" || n4 === "") {
        fromD = "";
        toD = "";
      }
      else {
        fromD = n3 + '/' + n2 + '/' + n1;
        toD = n6 + '/' + n5 + '/' + n4;
      }
      this.setState({ isloading: true });
      Axios.post(BimeManager.reactRedirectDomain,
        BimeManager.makeBody("/NovinInsuranceServices/Ml/api/Ml/CustomerPayStatus",
          !this.bid2 ?
            { ReshteId: rbimei, FromDate: fromD, ToDate: toD, Paid: 0, SanadType: "", BId: shbime, CodeMelli: UserManager.MelliCode() }
            : { ReshteId: this.reashte2, FromDate: fromD, ToDate: toD, Paid: 0, SanadType: "", BId: this.bid2, CodeMelli: UserManager.MelliCode() }
        ),
        BimeManager.header())
        .then((result) => {

          this.setState({ datapardakhtnashode: result.data, isloading: false });


        })
        .catch((error) => { alert(error) })
    }
  }

  removeFilter() {
    this.setState({ isloading: true });
    if (this.state.activeTab === 1) {
      Axios.post(BimeManager.reactRedirectDomain,
        BimeManager.makeBody("/NovinInsuranceServices/Ml/api/Ml/CustomerPayStatus",
          !this.bid2 ?
            { ReshteId: "", codeMelli: UserManager.MelliCode(), BId: "", FromDate: "", ToDate: "", Paid: 1 }
            : { ReshteId: this.reashte2, codeMelli: UserManager.MelliCode(), BId: this.bid2, FromDate: "", ToDate: "", Paid: 1 }

        ),
        BimeManager.header())
        .then((result) => {
          this.setState({ dataPardakhtShode: result.data, isloading: false });


        })
        .catch((error) => { alert(error) })
    }
    else {
      Axios.post(BimeManager.reactRedirectDomain,
        BimeManager.makeBody("/NovinInsuranceServices/Ml/api/Ml/CustomerPayStatus",
          !this.bid2 ?
            { ReshteId: "", codeMelli: UserManager.MelliCode(), BId: "", FromDate: "", ToDate: "", Paid: 0 }
            : { ReshteId: this.reashte2, codeMelli: UserManager.MelliCode(), BId: this.bid2, FromDate: "", ToDate: "", Paid: 0 }
        ),
        BimeManager.header())
        .then((result) => {
          this.setState({ datapardakhtnashode: result.data, isloading: false });


        })
        .catch((error) => { alert(error) })



    }
  }
  render() {
    return (

      <div>
        <Row>
          <Col sm="12" className="alignRight title">
            <h4>پرداخت های من</h4>
          </Col>
        </Row>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={this.state.activeTab === 1 ? 'active' : ''}
              onClick={() => { this.setState({ activeTab: 1 }) }}>
              پرداخت شده
                </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={this.state.activeTab === 2 ? 'active' : ''}
              onClick={() => { this.setState({ activeTab: 2 }) }}>
              پرداخت نشده
                </NavLink>
          </NavItem>
        </Nav>


        <div>
          <div className="serchlist-form">
            <div className="container-fluid Inquiry">
              <div className="container">
                <Form >
                  <FormGroup className="mb-2 mr-sm-2 mb-sm-0" row>
                    <Label for="exampleNumber" sm={3}>رشته بیمه ای</Label>
                    <Col sm={9}>
                      <Input type="select" name="select1" id="paymentSelect" value={this.state.reshtebimei} onChange={this.setreshtebimei}>
                        <option>انتخاب کنید</option>
                        {
                          (this.state.datareshte || this.state.datareshte.lenght!==0)? this.state.datareshte.map((reshte) => {
                            return <option value={reshte.ReshteId}>{reshte.ReshteCaption}</option>

                          }

                          ) : ''
                        }

                      </Input>
                    </Col>
                  </FormGroup>
                  <FormGroup className="mb-3 mr-sm-3 mb-sm-1" row>
                    <Label for="exampleNumber" sm={3}>شماره بیمه نامه</Label>
                    <Col sm={9}>
                      <Input type="text" value={this.state.shomarebime} name="shomarebime" id="exampleshomarebime" placeholder="" onChange={this.setshomarebimename} />
                    </Col>
                  </FormGroup>
                  <FormGroup className="mb-2 mr-sm-2 mb-sm-0" row>
                    <Label for="exampleDate" sm={3}>از تاریخ</Label>
                    <Col sm={3} md={2}>
                      <Input type="text" pattern="[0-9]*" value={this.state.number1} onChange={this.setDateDay} name="number1" id="exampleNumber1" placeholder="روز" />
                    </Col>
                    <Col sm={3} md={2}>
                      <Input type="text" pattern="[0-9]*" value={this.state.number2} onChange={this.setDateMonth} name="number2" id="exampleNumber2" placeholder="ماه" />
                    </Col>
                    <Col sm={3} md={2}>
                      <Input type="text" pattern="[0-9]*" value={this.state.number3} onChange={this.setDateYear} name="number3" id="exampleNumber3" placeholder="سال" />
                    </Col>
                  </FormGroup>
                  <FormGroup className="mb-2 mr-sm-2 mb-sm-0" row>
                    <Label for="exampleDate" sm={3}>تا تاریخ</Label>
                    <Col sm={3} md={2}>
                      <Input type="text" pattern="[0-9]*" value={this.state.number4} onChange={this.setDateDay2} name="number4" id="exampleNumber4" placeholder="روز" />
                    </Col>
                    <Col sm={3} md={2}>
                      <Input type="text" pattern="[0-9]*" value={this.state.number5} onChange={this.setDateMonth2} name="number5" id="exampleNumber5" placeholder="ماه" />
                    </Col>
                    <Col sm={3} md={2}>
                      <Input type="text" pattern="[0-9]*" value={this.state.number6} onChange={this.setDateYear2} name="number6" id="exampleNumber6" placeholder="سال" />
                    </Col>
                  </FormGroup>
                  <br />
                  <Col sm={12} >
                    <div className="buttons page">
                      <Button className="btn btn-secondary" onClick={() => this.filter(this.state.reshtebimei, this.state.shomarebime, this.state.number3, this.state.number2, this.state.number1, this.state.number6, this.state.number5, this.state.number4)}>
                        فیلتر</Button>
                      <Button className="btn btn-secondary" onClick={() => this.removeFilter()}>
                        حذف فیلتر</Button>
                    </div>
                  </Col>
                </Form>
              </div>
            </div>
          </div>

          <TabContent activeTab={this.state.activeTab}>
            <TabPane tabId={1}>
              {(!this.state.isloading) ? (
                <div className="container ListOfList">
                  <ListGroup>
                    <ListGroupItem >
                      {(this.state.dataPardakhtShode.lenght !== 0 || this.state.dataPardakhtShode) ? this.state.dataPardakhtShode.map((data2) => {
                        return (
                          <div className="border-List">
                            <Row>
                              <Col sm="12" className="alignRight"><span className="bold-head">رشته:</span>{data2.ReshteCaption}</Col>
                              <Col sm="12" className="alignRight"><span className="bold-head">شماره بیمه نامه:</span>{data2.FullBNo}</Col>
                              <Col sm="12" className="alignRight"><span className="bold-head">شماره الحاقیه:</span>{data2.ElhNo}</Col>
                              <Col sm="12" className="alignRight"><span className="bold-head">شرح:</span>{data2.Sharh}</Col>
                              <Col sm="12" className="alignRight"><span className="bold-head">تاریخ:</span>{data2.Date}</Col>
                              <Col sm="12" className="alignRight"><span className="bold-head">مبلغ:</span>{libs.StringFunctions.currancyPrint(data2.Amount) + ('ریال')}</Col>

                            </Row>

                            <br />
                          </div>

                        )
                      }) :
                        <div className="border-List"><Row>
                          <Col sm="12" className="alignCenter"><span className="bold-head">لیست پرداخت شده های شما خالی می باشد</span></Col>
                        </Row>

                          <br />
                        </div>

                      }

                    </ListGroupItem>
                  </ListGroup>
                </div>
              ) : (<ui.Preloader />)}
            </TabPane>

            <TabPane tabId={2}>
              {(!this.state.isloading) ? (
                <div className="container ListOfList">
                  <ListGroup>
                    <ListGroupItem >

                      {(this.state.datapardakhtnashode.lenght !== 0 || this.state.datapardakhtnashode) ? this.state.datapardakhtnashode.map((data3) => {


                        return (

                          <div className="border-List">

                            <Row>
                              <Col sm="12" className="alignRight"><span className="bold-head">رشته:</span>{data3.ReshteCaption}</Col>
                              <Col sm="12" className="alignRight"><span className="bold-head">شماره بیمه نامه:</span>{data3.FullBNo}</Col>
                              <Col sm="12" className="alignRight"><span className="bold-head">شماره الحاقیه:</span>{data3.ElhNo}</Col>
                              <Col sm="12" className="alignRight"><span className="bold-head">شرح:</span>{data3.Sharh}</Col>
                              <Col sm="12" className="alignRight"><span className="bold-head">تاریخ:</span>{data3.Date}</Col>

                              <Col sm="12" className="alignRight"><span className="bold-head">مبلغ:</span>{libs.StringFunctions.currancyPrint(data3.Amount) + ('ریال')}</Col>


                              <Col sm="12" className="alignRight"> {(data3.Payable === 1) ?


                                <Button onClick={() => this.redirectPay(data3.SrdId)} target="_blank">{(!this.state.isLoading) ?
                                  <span><ui.Preloader /> در حال وصل شدن به درگاه پرداخت</span> : <span>پرداخت الکترونیکی</span>}</Button>
                                : ''
                              }
                              </Col>
                            </Row>

                            <br />

                          </div>

                        )
                      }

                      )
                        :
                        <div className="border-List">

                          <Row>
                            <Col sm="12" className="alignCenter"><span className="bold-head">لیست پرداخت نشده های شما خالی می باشد</span></Col>

                          </Row>

                          <br />

                        </div>
                      }

                    </ListGroupItem>
                  </ListGroup>
                </div>
              ) : (<ui.Preloader />)}
            </TabPane>
          </TabContent>
         
        </div>
      </div>



    );
  }
}
export default SearchList;


// WEBPACK FOOTER //
// ./src/components/SearchList/SearchList.js